export const DEFAULT_SECTION_DIALOG_MODES = Object.freeze({
  CREATE: 'create',
  MOVE: 'move',
  MOVE_TO_SECTION_OR_CREATE: 'moveToSectionOrCreate',
})

function createDefaultSectionDialogState(overrides = {}) {
  return {
    show: false,
    availableSections: [],
    items: [],
    previousItems: [],
    scoringType: null,
    source: 'checklist',
    mode: DEFAULT_SECTION_DIALOG_MODES.CREATE,
    existingSectionName: '',
    ...overrides,
  }
}

function createDeleteSectionDecisionDialogState(overrides = {}) {
  return {
    show: false,
    sectionIndex: null,
    items: [],
    previousItems: [],
    availableSections: [],
    scoringType: null,
    ...overrides,
  }
}

function createScoringWarningDialogState(overrides = {}) {
  return {
    show: false,
    title: '',
    text: '',
    actionText: '',
    ...overrides,
  }
}

export {
  createDefaultSectionDialogState,
  createDeleteSectionDecisionDialogState,
  createScoringWarningDialogState
}
